
(function () {
  'use strict';

  const STORAGE_KEY = 'wzg-influencer-cart-open';
  const params = new URLSearchParams(window.location.search);
  const root = window.Shopify?.routes?.root || '/';

  // 1. Warenkorb nach der Shopify-Weiterleitung öffnen.
  const savedState = sessionStorage.getItem(STORAGE_KEY);

  if (savedState) {
    sessionStorage.removeItem(STORAGE_KEY);

    try {
      const state = JSON.parse(savedState);
      const age = Date.now() - state.timestamp;

      if (
        age >= 0 &&
        age < 60000 &&
        state.path === window.location.pathname
      ) {
        customElements.whenDefined('theme-drawer').then(() => {
          const openCart = () => {
            const drawer = document.getElementById('cart-drawer');

            if (drawer && typeof drawer.open === 'function') {
              requestAnimationFrame(() => {
                requestAnimationFrame(() => drawer.open());
              });
            } else {
              console.warn('[WZG] Cart Drawer nicht gefunden');
            }
          };

          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', openCart, {
              once: true
            });
          } else {
            openCart();
          }
        });
      }
    } catch (error) {
      console.error('[WZG] Drawer-Status ungültig', error);
    }
  }

  // 2. Nur spezielle Influencer-Links ausführen.
  if (params.get('buzz_campaign') !== '1') return;

  const variant = params.get('variant');
  const discount = params.get('discount');

  if (
    !variant ||
    !/^\d+$/.test(variant) ||
    !discount ||
    !/^[a-zA-Z0-9_-]+$/.test(discount)
  ) {
    console.error('[WZG] Ungültiger Kampagnenlink');
    return;
  }

  async function startCampaign() {
    try {
      // 3. Vorhandenen Warenkorb prüfen.
      const response = await fetch(root + 'cart.js', {
        credentials: 'same-origin'
      });

      if (!response.ok) {
        throw new Error('Warenkorb konnte nicht geladen werden');
      }

      const cart = await response.json();

      const exists = cart.items.some(
        item => String(item.variant_id) === variant
      );

      // 4. Produkt nur hinzufügen, wenn es noch nicht vorhanden ist.
      if (!exists) {
        const addResponse = await fetch(root + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: Number(variant),
              quantity: 1
            }]
          })
        });

        if (!addResponse.ok) {
          const errorText = await addResponse.text();
          throw new Error('Produkt konnte nicht hinzugefügt werden: ' + errorText);
        }
      }

      // 5. Technische Kampagnenparameter entfernen.
      const destinationParams = new URLSearchParams(params);
      destinationParams.delete('buzz_campaign');
      destinationParams.delete('variant');
      destinationParams.delete('discount');
      destinationParams.delete('buzz_open_cart');

      const destination =
        window.location.pathname +
        (destinationParams.toString()
          ? '?' + destinationParams.toString()
          : '');

      // 6. Warenkorb-Öffnung für die Weiterleitung speichern.
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        timestamp: Date.now(),
        path: window.location.pathname
      }));

      // 7. Rabatt aktivieren und zur Zielseite zurückkehren.
      const discountUrl =
        root +
        'discount/' +
        encodeURIComponent(discount) +
        '?redirect=' +
        encodeURIComponent(destination);

      window.location.assign(discountUrl);

    } catch (error) {
      sessionStorage.removeItem(STORAGE_KEY);
      console.error('[WZG Influencer Cart]', error);
    }
  }

  startCampaign();
})();
